<template>
  <section class="hlt">
    <div v-if="tarif.empfehlung_type == 3" class="hlt__rec hlt__rec--best">
      <div class="hlt__rec-eyebrow">EMPFEHLUNG</div>
      <div class="hlt__rec-title">
        Beste Leistung
        <span class="hlt__rec-tip">Tipp</span>
      </div>
    </div>
    <div
      v-else-if="tarif.empfehlung_type == 2 || tarif.empfehlung_type == 1"
      class="hlt__rec hlt__rec--alt"
    >
      <div class="hlt__rec-eyebrow">EMPFEHLUNG</div>
      <div class="hlt__rec-title">
        Sehr gute Alternative
        <span class="hlt__rec-tip">Tipp</span>
      </div>
    </div>

    <div class="hlt__head">
      <v-icon icon="mdi-shield-check-outline" size="14" class="mr-1" />
      Tarif-Vorteile
    </div>
    <ul class="hlt__list">
      <li
        v-for="(item, index) in truncateLog(tarif.log, tarif.empfehlung_type)"
        :key="index"
        class="hlt__li"
      >
        <span class="hlt__check">
          <v-icon icon="mdi-check-bold" size="11" />
        </span>
        <span class="hlt__text">
          <span v-html="nl2br(item.value)"></span>
          <a
            v-if="item.info_pop == 'altersKhPop'"
            class="hlt__link"
            @click="berechnungStore.setShowPopApp('altersrueck')"
          >
            Wieso ist das wichtig?
          </a>
          <a
            v-if="tarif.sofortversichert && item.info_pop == 'sofort'"
            class="hlt__link"
            @click="berechnungStore.setShowPop(tarif, 'sofortpop')"
          >
            mehr Infos dazu
          </a>
        </span>
      </li>
    </ul>
    <div v-if="tarif.antraglink" class="hlt__foot">
      <router-link :to="tarif.antraglink" class="hlt__cta">
        jetzt kostenlos Infopaket anfordern →
      </router-link>
    </div>
  </section>
</template>

<script setup>
  import { defineProps } from "vue";
  import { useBerechnungStore } from "@/stores/berechnung";
  import { useNl2Br } from "@/composable/useNl2Br";
  const { nl2br } = useNl2Br();
  const berechnungStore = useBerechnungStore();

  defineProps({
    tarif: { type: Object, default: () => ({}) },
    showMobile: { type: Boolean },
    berechnung: { type: Object, default: () => ({}) },
  });

  const truncateLog = (log, empfehlungType) => {
    const filteredLog = log.filter((entry) => entry.emp_only === 0);
    if (empfehlungType === 0 && log.length > 3) {
      return filteredLog.slice(0, 3);
    }
    if (empfehlungType > 0) {
      return log.filter((entry) => entry.noShowEmpf === 0);
    }
    return log;
  };
</script>

<style scoped>
  .hlt {
    background: #ffffff;
    border: 1px solid #d8dde5;
    border-radius: 3px;
    padding: 0;
    overflow: hidden;
  }

  .hlt__rec {
    padding: 8px 12px 9px;
    border-bottom: 1px solid #eef1f6;
    position: relative;
  }
  .hlt__rec--best {
    background: #fff5cc;
    border-left: 3px solid #f6a800;
  }
  .hlt__rec--alt {
    background: #f0f5fa;
    border-left: 3px solid #0f4c81;
  }
  .hlt__rec-eyebrow {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: #8a6d00;
    margin-bottom: 1px;
  }
  .hlt__rec--alt .hlt__rec-eyebrow {
    color: #0f4c81;
  }
  .hlt__rec-title {
    font-size: 14px;
    font-weight: 800;
    color: #0f172a;
    letter-spacing: -0.1px;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .hlt__rec-tip {
    display: inline-flex;
    align-items: center;
    padding: 1px 6px;
    background: #2e7d32;
    color: #fff;
    font-size: 9.5px;
    font-weight: 800;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    border-radius: 2px;
  }

  .hlt__head {
    display: flex;
    align-items: center;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1px;
    color: #5b6473;
    text-transform: uppercase;
    padding: 10px 12px 6px;
  }
  .hlt__head .v-icon {
    color: #0f4c81;
  }

  .hlt__list {
    list-style: none;
    margin: 0;
    padding: 0 12px 12px;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .hlt__li {
    display: grid;
    grid-template-columns: 16px 1fr;
    align-items: start;
    gap: 8px;
    font-size: 13px;
    line-height: 1.45;
    color: #1f2937;
  }
  .hlt__check {
    width: 16px;
    height: 16px;
    margin-top: 2px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #e7f3ea;
    color: #2e7d32;
  }
  .hlt__check :deep(.v-icon) {
    color: #2e7d32;
  }
  .hlt__text {
    min-width: 0;
  }
  .hlt__link {
    display: inline-block;
    margin-left: 2px;
    color: #0f4c81;
    font-weight: 600;
    text-decoration: none;
    border-bottom: 1px dotted #0f4c81;
    cursor: pointer;
  }
  .hlt__link:hover {
    border-bottom-style: solid;
  }

  .hlt__foot {
    border-top: 1px dashed #eef1f6;
    padding: 8px 12px 10px;
  }
  .hlt__cta {
    display: inline-block;
    font-size: 12.5px;
    font-weight: 700;
    color: #0f4c81;
    text-decoration: none;
    letter-spacing: 0.2px;
  }
  .hlt__cta:hover {
    text-decoration: underline;
  }
</style>
